/**
 * ReactFlow `nodeTypes` registry — maps each backend node-type constant to its
 * typed canvas component. The store sets a node's ReactFlow `type` to the
 * backend constant (e.g. `rag.query`), so this map wires the renderer.
 *
 * Defined as a module-level constant so the same identity is reused across
 * renders (ReactFlow warns when `nodeTypes` is recreated each render).
 */

import type { NodeTypes } from 'reactflow';
import { NODE_TYPES } from '../../lib/agents';
import { TriggerNode } from './TriggerNode';
import { RagNode } from './RagNode';
import { LlmNode } from './LlmNode';
import { ConditionNode } from './ConditionNode';
import { TransformNode } from './TransformNode';
import { OutputNode } from './OutputNode';

export const canvasNodeTypes: NodeTypes = {
  [NODE_TYPES.TRIGGER_MANUAL]: TriggerNode,
  [NODE_TYPES.RAG_QUERY]: RagNode,
  [NODE_TYPES.LLM_CALL]: LlmNode,
  [NODE_TYPES.CONDITION_IF]: ConditionNode,
  [NODE_TYPES.TRANSFORM_MAP]: TransformNode,
  [NODE_TYPES.OUTPUT_RETURN]: OutputNode,
};
